import { render, staticRenderFns } from "./social-info.vue?vue&type=template&id=7277d2aa&scoped=true&"
import script from "./social-info.vue?vue&type=script&lang=js&"
export * from "./social-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7277d2aa",
  null
  
)

export default component.exports